/** Scroll container for the in-contest picks list (CompetitionContent). */
export const COMPETITION_PICKS_SCROLL_ID = 'competition-picks-scroll';
